module.exports = __webpack_public_path__ + "img/icon6.9447b6b1.png";